"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M20 8h-5v2h3v11H6V10h3V8H4v15h16z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M11 16h2V5h3l-4-4-4 4h3z"
}, "1")], 'IosShareSharp');